module.exports = __webpack_public_path__ + "img/html.9c141d60.svg";